import React from "react";
import { Col } from "react-bootstrap";
import TooltipHelper from "./TooltipHelper";
// ? this is not working and there are issues with fulfilling desired order in the chunk files
// import "./AggregateCard.scss";

export interface AggregateCardProps {
  title: string;
  rowSpan: number;
  filterShowTooltip: boolean;
  filterTooltipText: string;
  toolTipText?: string;
  metricValue: string | number;
  metricColor: string;
  datePreText?: string;
  metricSubText?: string;
  subMetric?: string;
  startDate?: string | null;
  endDate?: string | null;
  /*
   * Does the entire card change when a date filter is applied?
   */
  metricDateFilteredEnabled?: boolean;
  /*
   * Does ONLY the submetric change when a date filter is applied?
   */
  subMetricDateFilteredEnabled?: boolean;
}

export default function AggregateCard(props: AggregateCardProps) {
  const {
    title,
    rowSpan,
    filterShowTooltip,
    filterTooltipText,
    toolTipText,
    metricValue,
    metricColor,
    subMetric,
    startDate,
    endDate,
    datePreText,
    metricSubText,
    metricDateFilteredEnabled = false,
    subMetricDateFilteredEnabled = false,
  } = props;

  return (
    <Col
      md={rowSpan}
      xs={12}
      className="m-stats-cards-card-wrapper card-wrapper aggregate-card"
    >
      <div className="card text-center h-100 mb-0">
        <div className="d-flex justify-content-end">
          {filterShowTooltip ? (
            <TooltipHelper altIcon={"far fa-filter"} text={filterTooltipText} />
          ) : null}
          {metricDateFilteredEnabled ? (
            <TooltipHelper
              altIcon="far fa-calendar"
              text={"Filtered on Date Range"}
            />
          ) : null}
          {toolTipText ? <TooltipHelper text={toolTipText} /> : null}
        </div>
        <p className="card-title h5">{title}</p>
        <div
          style={{ color: metricColor }}
          className={metricSubText ? "d-flex justify-content-center" : ""}
        >
          <span className="card-title h1 mb-0">{metricValue}</span>
          {metricSubText ? (
            <span style={{ color: "#333333" }} className="h6 mb-0 ml-2 pt-4">
              {metricSubText}
            </span>
          ) : null}
        </div>
        {startDate && endDate ? (
          <div>
            {datePreText ? (
              <p className="text-secondary mb-0">{datePreText}</p>
            ) : null}
            <p className="text-secondary mb-0">
              {startDate} <span className="font-weight-bold">...</span>{" "}
              {endDate}
            </p>
          </div>
        ) : null}
        {subMetric ? (
          <React.Fragment>
            <hr />
            <div className="d-flex justify-content-center">
              <p className="mb-0 text-secondary">{subMetric}</p>
              {subMetricDateFilteredEnabled ? (
                <TooltipHelper
                  altIcon="far fa-calendar"
                  toolTipClass=" mt-1"
                  text={"Filtered on Date Range"}
                />
              ) : null}
            </div>
          </React.Fragment>
        ) : null}
      </div>
    </Col>
  );
}
